import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors } from '../../../Globals/styles';

class DailyreportSwitch extends Component{
  render()  {
    const { listOfDailyReports, onDailyReportChange, currentDailyReportId,
    canCreateNew, createNew } = this.props;


    let listOfDailyReportNodes = [];
    listOfDailyReports.forEach((dailyReportObject, index) => {
      if(dailyReportObject.deleted){
        return;
      }
      let isCurrent = currentDailyReportId===dailyReportObject.no;
      listOfDailyReportNodes.push(
        <div
          key={dailyReportObject.no}
          style={[styles.dailyReportContainer, index===0 && styles.first, isCurrent && styles.isCurrent]}
          onClick={() => {if(!isCurrent)onDailyReportChange(dailyReportObject.no)}}>
          <div ref={dailyReportObject.no} className="waves-btn wavesHover" style={styles.dailyReportLink}>
            <i className="fa fa-file-text-o" aria-hidden="true"></i>
            <div style={styles.text}>#{index+1}</div>
          </div>
        </div>
      )
    })

    return (
      <div style={styles.container}>
        {listOfDailyReportNodes}
        {
          canCreateNew ?
          <div
            style={[styles.dailyReportContainer, styles.createNew]}
            onClick={createNew}>
            <div ref="opretNy" className="waves-btn wavesHover" style={[styles.dailyReportLink, styles.createNew]}>
              <i className="fa fa-plus-square-o" aria-hidden="true"></i>
              <div style={styles.text}>Opret ny</div>
            </div>
          </div>
          :
          null
        }
      </div>
    );
  }
}

var styles = {
  container: {
    height: '50px',
    padding: '0 12px',
    lineHeight: '50px'
  },
  dailyReportContainer: {
    width: '50px',
    height: '30px',
    textAlign: 'center',
    borderRight: '1px solid ' + semanticColors.mainBackground,
    display: 'inline-block',
    position: 'relative'
  },
  first: {
    borderLeft: '1px solid ' + semanticColors.mainBackground
  },
  dailyReportLink: {
    position: 'absolute',
    fontSize: '22px',
    lineHeight: '20px',
    width: '50px',
    //waves overrides
    padding: '0',
    verticalAlign: 'inherit',
    left: '0'
  },
  text: {
    fontSize: '12px',
    fontWeight: '600'
  },
  isCurrent: {
    color: semanticColors.info
  },
  createNew: {
    borderRight: 'none',
    width: '65px'
  }
}
  DailyreportSwitch.propTypes = {
    listOfDailyReports: PropTypes.arrayOf(PropTypes.shape({
      no: PropTypes.string.isRequired,
      deleted: PropTypes.bool.isRequired
    })).isRequired,
    onDailyReportChange: PropTypes.func.isRequired,
    currentDailyReportId: PropTypes.string.isRequired,
    canCreateNew: PropTypes.bool.isRequired,
    createNew: PropTypes.func.isRequired
  };
export default Radium(DailyreportSwitch)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/dailyReportSwitch.jsx